export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    title:  that.$l('table_label_repTypeName') || '时间',
    field: 'repTypeName',
    minWidth: 240,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title:  that.$l('table_label_replenish') || '补货',
    field: 'replenish',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'replenish' },
  },
  {
    title:  that.$l('table_label_reorder') || '翻单',
    field: 'reorder',
    minWidth: 120,
    align: 'left',
    showHeaderOverflow: true,
    slots: { default: 'reorder' },
  },
  {
    title: that.$l('table_label_air') || '空运',
    field: 'isAir',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'air' },
  },
  {
    title: that.$l('table_label_fastShipping') || '快船',
    field: 'isFastShipping',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'fastShipping' },
  },
  {
    title: that.$l('table_label_slowShipping') || '慢船',
    field: 'isSlowShipping',
    width: 100,
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'slowShipping' },
  },
]
